<td-address-page scope="auction-history" #page *transloco="let t">
    <h1 my-title>{{ t('auction-history-list.title-my') }}</h1>
    <span other-subtitle>{{ t('auction-history-list.title-owned-by') }}</span>

    <td-auction-history-table *ngIf="page.validAddress" [address]="page.address"></td-auction-history-table>
</td-address-page>
